// extracted by mini-css-extract-plugin
export default {"botonFav":"style_botonFav__2KYfp"};